function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.17588 9.52417C1.17588 14.2186 4.80346 18.0242 9.2783 18.0242C13.7531 18.0242 17.3807 14.2186 17.3807 9.52417C17.3807 4.82975 13.7531 1.02417 9.2783 1.02417C4.80346 1.02417 1.17588 4.82975 1.17588 9.52417ZM0.222656 9.52417C0.222656 4.27747 4.27701 0.0241699 9.2783 0.0241699C14.2796 0.0241699 18.3339 4.27747 18.3339 9.52417C18.3339 14.7709 14.2796 19.0242 9.2783 19.0242C4.27701 19.0242 0.222656 14.7709 0.222656 9.52417ZM9.2783 4.02417C9.54153 4.02417 9.75491 4.24803 9.75491 4.52417V10.5242C9.75491 10.8003 9.54153 11.0242 9.2783 11.0242C9.01507 11.0242 8.80169 10.8003 8.80169 10.5242V4.52417C8.80169 4.24803 9.01507 4.02417 9.2783 4.02417ZM8.80169 14.5242C8.80169 14.248 9.01507 14.0242 9.2783 14.0242C9.54153 14.0242 9.75491 14.248 9.75491 14.5242C9.75491 14.8003 9.54153 15.0242 9.2783 15.0242C9.01507 15.0242 8.80169 14.8003 8.80169 14.5242Z",
  fill: "#4979C0"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.a20a2862.svg";
export { ForwardRef as ReactComponent };